'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bindActions = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bindActions = exports.bindActions = function bindActions() {
	if (localStorage.getItem("mcn_seen") === null) {
		setTimeout(_handlers.openModal, 5000);
		(0, _handlers.openModal)();
		$("#mce-MMERGE3-day").attr("value", "15");
	}

	$("#mc-embedded-subscribe").on('submit', function (e) {
		localStorage.setItem('mcn_seen', 'true');
	});

	$(_Dom2.default.mailChimpCloseModal).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.closeModal)();
		localStorage.setItem('mcn_seen', 'true');
	});

	$(_Dom2.default.overlay).on('click', function (event) {
		event.preventDefault();
		(0, _handlers.closeModal)();
	});
};